import { useInfiniteQuery, useMutation, useQuery } from '@tanstack/react-query';
import axiosInstance from './axios';
import { GetUsersRequest, GetUsersResponseT } from '../types/userType';
import { AddUserSchemaT } from '../types/schema/userScheme';

export const useInfiniteGetAllUsers = (postData: GetUsersRequest) => {
  return useInfiniteQuery({
    queryKey: [`useInfiniteGetAllUsers`, postData],
    queryFn: async () => {
      const { data } = await axiosInstance.post(`/user/all`, {
        ...postData,
      });
      return data as GetUsersResponseT[] & { hasNextPage?: boolean };
    },
    getNextPageParam: (lastPage, allPages) => {
      const nextPage = lastPage.hasNextPage ? allPages.length + 1 : undefined;
      return nextPage;
    },
    initialPageParam: 1,
  });
};

export const useGetAllUsers = (postData: GetUsersRequest) => {
  return useQuery({
    queryKey: ['useGetAllUsers', postData],
    queryFn: async () => {
      const { data } = await axiosInstance.post(`/user/all`, postData);
      return data as GetUsersResponseT;
    },
  });
};

export const useAddUser = () => {
  return useMutation({
    mutationKey: ['useAddUser'],
    mutationFn: async (postData: AddUserSchemaT) => {
      const { data } = await axiosInstance.post('/user/register', postData);
      return data;
    },
  });
};

export const useGetAUser = ({ email }: { email: string }) => {
  return useQuery({
    queryKey: ['useGetAUser', email],
    queryFn: async () => {
      const { data } = await axiosInstance.get(`/user/${email}`);
      return data as any;
    },
    enabled: !!email,
  });
};

export const useUpdateUser = () => {
  return useMutation({
    mutationKey: ['useUpdateUser'],
    mutationFn: async (postData: AddUserSchemaT) => {
      const { data } = await axiosInstance.put('/user/update', postData);
      return data as any;
    },
  });
};
